import { useDeleteTemplateMutation } from '@/graphql/types';

export default function (template: { id: string }) {
  const mutation = useDeleteTemplateMutation({});

  function call() {
    return mutation.mutate({
      id: template.id
    });
  }

  return {
    ...mutation,
    call
  };
}
